import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contributing-guidelines"
    }}>{`Contributing guidelines`}</h1>
    <h2 {...{
      "id": "setup-local-development"
    }}>{`Setup local development`}</h2>
    <ol>
      <li parentName="ol">{`clone this repo`}</li>
      <li parentName="ol">{`have `}<inlineCode parentName="li">{`yarn`}</inlineCode>{` install package dependencies and manage the symlinking between packages for you`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`git clone ...encodable && cd encodable
yarn install
yarn build
`}</code></pre>
    <h2 {...{
      "id": "file-organization"
    }}>{`File organization`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/lerna/lerna/"
      }}>{`lerna`}</a>{` and `}<a parentName="p" {...{
        "href": "https://yarnpkg.com"
      }}>{`yarn`}</a>{` are used to manage versions
and dependencies between packages in this monorepo.`}</p>
    <pre><code parentName="pre" {...{}}>{`encodable/
  lerna.json
  package.json
  ...
  packages/
    package1/
      package.json
      ...
      src/
      test/  # unit tests
      types/ # typescript type declarations
      ...
      lib/   # commonjs output
      esm/   # es module output
      ...
    ...
`}</code></pre>
    <h2 {...{
      "id": "builds-linting-and-testing"
    }}>{`Builds, linting, and testing`}</h2>
    <p>{`Each package defines its own build config, linting, and testing. You can have lerna run commands
across all packages using the syntax `}<inlineCode parentName="p">{`yarn test`}</inlineCode>{` (or `}<inlineCode parentName="p">{`yarn test:watch`}</inlineCode>{` for watch mode) from
the root `}<inlineCode parentName="p">{`encodable`}</inlineCode>{` directory.`}</p>
    <h2 {...{
      "id": "committing"
    }}>{`Committing`}</h2>
    <p>{`This repository follows
`}<a parentName="p" {...{
        "href": "https://www.conventionalcommits.org/en/v1.0.0-beta.3/"
      }}>{`conventional commits`}</a>{` guideline for commit
messages and has a `}<inlineCode parentName="p">{`commitlint`}</inlineCode>{` hook which will require you to have the valid commit message before
committing. You can use `}<inlineCode parentName="p">{`npm run commit`}</inlineCode>{` to help you create a commit message.`}</p>
    <h2 {...{
      "id": "publishing"
    }}>{`Publishing`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn bump-version-auto
# or manual
yarn bump-version-force
# Then follow the prompt to pick new versions for each package
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      